import React from "react";
import { OrderButton } from "../atoms/buttons";
import RiderLottie from "./riderLottie";
import { Div, Row, Col, Text } from "atomize";
import { LearnMoreButton } from "../../components/atoms/buttons";

const HybrydeBikes = () => {
  return (
    <div>
      <Row m={{ y: "8rem" }} align="center">
        <Col>
          <Div bg="#FFFFFF" shadow="4" p="1rem" rounded="20px" m="0.5rem">
            <Div d="flex" justify="center">
              <RiderLottie />
            </Div>
            <hr />
            <Div d="flex" justify="space-between" align="center">
              <Div>
                <Text textWeight="300">Price</Text>
                <Text TextSize="display1" textWeight="800">
                  $750
                </Text>
              </Div>
              <OrderButton />
            </Div>
          </Div>
        </Col>
        <Col>
          <Text textSize="36px" textWeight="700" m={{ b: "1rem" }}>
            Hybrid Bikes
          </Text>
          <Text
            textWeight="300"
            textSize="18px"
            textColor="#7D7987"
            m={{ b: "1rem" }}
            style={{ lineHeight: "30px" }}
          >
            Dummy Text progressive, and affordable healthcare, <br />
            accessible on mobile and online for everyone. To us, it’s <br />
            not just work. We take pride <br />
            in the solutions we deliver
          </Text>
          <LearnMoreButton />
        </Col>
      </Row>
    </div>
  );
};

export default HybrydeBikes;
